export const REFERRAL_FORM_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    desktop_image: "",
    mobile_image: "",
    gradient_angle: "254deg",
    gradient_start_color: "rgba(0, 0, 0, 0.00)",
    gradient_start_position: "-25.81%",
    gradient_end_color: "#0A3D5B",
    gradient_end_position: "78.26%",
    mobile_gradient_angle: "0deg",
    mobile_gradient_start_color: "rgba(5, 33, 50, 0.80)",
    mobile_gradient_start_position: "0%",
    mobile_gradient_end_color: "rgba(5, 33, 50, 0.80)",
    mobile_gradient_end_position: "100%",
    banner_title: "",
    form_header_background_color: "",
    form_title_text: "",
    form_title_color: "",
    form_description_text: "",
    form_description_color: "",
    button_text: "",
    button_text_color: "",
    button_color: "",
    verify_text: "",
    verify_text_color: "",
    enter_otp_title: "",
    enter_otp_title_color: "",
    otp_sent_text_color: "",
    edit_text_color: "",
    resend_text_color: "",
  },

  REFERRAL_FORM_FIELDS_CONFIG: [
    {
      fieldName: "desktop_image",
      label: "Desktop Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Desktop Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_image",
      label: "Mobile Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Mobile Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "alt_image",
      label: "Image Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for background image",
      required: false,
      defaultValue: "Referral form background",
    },
    {
      fieldName: "gradient_angle",
      label: "Gradient Angle",
      value: "254deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter gradient angle (e.g., 254deg)",
      required: false,
      defaultValue: "254deg",
    },
    {
      fieldName: "gradient_start_color",
      label: "Gradient Start Color",
      value: "rgba(0, 0, 0, 0.00)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(0, 0, 0, 0.00)",
      required: false,
      defaultValue: "rgba(0, 0, 0, 0.00)",
    },
    {
      fieldName: "gradient_start_position",
      label: "Gradient Start Position",
      value: "-25.81%",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter gradient start position (e.g., -25.81%)",
      required: false,
      defaultValue: "-25.81%",
    },
    {
      fieldName: "gradient_end_color",
      label: "Gradient End Color",
      value: "#0A3D5B",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "#0A3D5B or rgba(10, 61, 91, 1)",
      required: false,
      defaultValue: "#0A3D5B",
    },
    {
      fieldName: "gradient_end_position",
      label: "Gradient End Position",
      value: "78.26%",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter gradient end position (e.g., 78.26%)",
      required: false,
      defaultValue: "78.26%",
    },
    {
      fieldName: "mobile_gradient_angle",
      label: "Mobile Gradient Angle",
      value: "0deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter mobile gradient angle (e.g., 0deg)",
      required: false,
      defaultValue: "0deg",
    },
    {
      fieldName: "mobile_gradient_start_color",
      label: "Mobile Gradient Start Color",
      value: "rgba(5, 33, 50, 0.80)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(5, 33, 50, 0.80)",
      required: false,
      defaultValue: "rgba(5, 33, 50, 0.80)",
    },
    {
      fieldName: "mobile_gradient_start_position",
      label: "Mobile Gradient Start Position",
      value: "0%",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter mobile gradient start position (e.g., 0%)",
      required: false,
      defaultValue: "0%",
    },
    {
      fieldName: "mobile_gradient_end_color",
      label: "Mobile Gradient End Color",
      value: "rgba(5, 33, 50, 0.80)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(5, 33, 50, 0.80)",
      required: false,
      defaultValue: "rgba(5, 33, 50, 0.80)",
    },
    {
      fieldName: "mobile_gradient_end_position",
      label: "Mobile Gradient End Position",
      value: "100%",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter mobile gradient end position (e.g., 100%)",
      required: false,
      defaultValue: "100%",
    },
    {
      fieldName: "banner_title",
      label: "Banner Title",
      value: "",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder: "Enter banner title",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "form_header_background_color",
      label: "Form Header Background Color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select form header background color",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "form_title_text",
      label: "Form Title Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter form title text",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "form_title_color",
      label: "Form Title Color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select form title color",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "form_description_text",
      label: "Form Description Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter form description text",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "form_description_color",
      label: "Form Description Color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select form description color",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "button_text",
      label: "Button Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter button text",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "button_text_color",
      label: "Button Text Color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select button text color",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "button_color",
      label: "Button Color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select button color",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "verify_text",
      label: "Verify Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter verify text",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "verify_text_color",
      label: "Verify Text Color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select verify text color",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "enter_otp_title",
      label: "Enter OTP Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter OTP title text",
      required: false,
      defaultValue: "Enter OTP",
    },
    {
      fieldName: "enter_otp_title_color",
      label: "Enter OTP Title Color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select enter OTP title color",
      required: false,
      defaultValue: "#0A3D5B",
    },
    {
      fieldName: "otp_sent_text_color",
      label: "OTP Sent Text Color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select OTP sent text color",
      required: false,
      defaultValue: "#0A3D5B",
    },
    {
      fieldName: "edit_text_color",
      label: "Edit Text Color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select edit text color",
      required: false,
      defaultValue: "#F74958",
    },
    {
      fieldName: "resend_text_color",
      label: "Resend Text Color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Select resend text color",
      required: false,
      defaultValue: "#0A3D5B",
    },
  ],

  METADATA_FIELDS: [],
};

